@if (initialized) {
  @if (step === 'add-phonenumber') {
    <app-order-trial-phonenumber
      (selected)="onTrialPhonenumberSelected($event)"
      (backEmitter)="onTrialPhonenumberBack()"
      [historyBack]="false"
    ></app-order-trial-phonenumber>
  }
  @if (step === 'completed') {
    <app-phonenumber
      [hideBackButton]="true"
      [trialPhonenumber]="trialPhoneNumber.phonenumber"
      (selected)="onPhonenumberSelected($event)"
    ></app-phonenumber>
  }
}
